import React, { useEffect,useState } from "react";
import { Button, Empty,Pagination,Select } from "antd";

import useStatsStore from "../../store/stats.store";
import useMembersStore from "../../store/members.store";

import Table from "../Table";
import "./sourcing.scss";
import useSourcingStore from "../../store/sourcing.store";
import FilterSourcing from "../filterSourcing";

export default function SourcingVendors(props) {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
   const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const { sourcingDetails,getSourcingDetails,sourcingDetailsJd,sourcingDetailsTotalCount } = useSourcingStore();

  useEffect(() => {
  }, []);

  const titleList = [
    "Sr. No.",
    "Client",  
    "TA",
    "JD Title",    
    "Resume ID",
    "Name", 
    "Missing Skills",
    "Final Score",
    "Suitability",    
    "Sourced On",
    "Last Updated On",
    "Last Updated By",
    "Candidate Status",
    "Resume Status",
    "Interview Status",
    "BGV Status",
    "Offer Status"
  ];
  const getJD =(jdID) =>{
    const jd = sourcingDetailsJd.filter((item)=> item?.qhcompanyjid===jdID)
    return jd[0]
  }
  function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    }  
  
  const mapResumeQuality =(qual) =>{
    if(qual >=60){
      return "Good Match"
    }else if (qual >=50 && qual<60){
      return "Above Average"
    }else if ((qual >=40) && (qual<50)){
      return "Average"
    }else if ((qual >=30) && (qual<40)){
      return "Below Average"
    }else if (qual<30){
      return "Not Suitable"
    }else{
      return "Unknown"
    }
  }
  const sDetailData = sourcingDetails?.map((item, idx) => {
    const scorelist = item?.resumescore?.scorelist || {};
    const keywordsObj = scorelist?.skill_scores?.keywords || {};
    const keywordString = Object.entries(keywordsObj)
          .filter(([_, value]) => (value.avg ?? 0) <30 )
          .map(([key]) => key)
          .join(", ");
    const jd = getJD (item.qhcompanyjid)
    return {
      id: (idx + 1)+ (currentPage-1)*pageSize, 
      client_name: jd?.jdclient?.clientname,
      ta_name: jd.jdclient?.taname,
      title: '['+jd.qhcompanyjid+'] '+jd.jddetails?.title,
      resumeID:item.qhrid,
      name: item.applicationid.name,
      matchingskills: keywordString,
      finalScore:item?.resumescore?.score + " % ",
      resumeSuitability: mapResumeQuality(item?.resumescore?.score),
      uploadedon: formatUnixDate(item?.sourcingdetails.teamdetails.timestamp),
      lastUpdateOn: formatUnixDate(item?.timestamp),
      uploadedby: item?.updatedby,
      candidateStatus: item?.candidatestatus.status,
      resumeStatus: item?.resumestatus.status,
      interviewStatus: item?.interviewstatus.status,
      bgvStatus: item?.bgvstatus.status,
      offerStatus: item?.selectionstatus.status,      
    };
  });

  return (
    <div className="sourcing-vendors-wrapper">
      <div>
      <FilterSourcing
        filtername = {"getSourcingDetails"}
        initRange={"24"}
        initPrio={"All"}
        initJDStatus={"Active"} 
        pageNo = {currentPage}
        pageSize = {pageSize}        
        enableTeamMember  
        enableTAs 
        enableRange
        enablePriority
        enableJdStatus
        enableCustomers
        enableResumeQuality 
        enableCandidateStatus 
        enableInterviewStatus   
        enableResumeStatus
        handleFilter={getSourcingDetails}
        setCurrentPage={setCurrentPage}
      />
      <div></div>
      </div>
      <div className="sourcing-title">
       ({sourcingDetailsTotalCount || 0}){" "} Sourcing Results Found 
      </div>
      <div>
        {sDetailData?.length > 0 ? (
          <Table
            isClickable={true}
            isJDPage={true}
            titleList={titleList}
            data={sDetailData}
            columnWidth={[
              50, 100, 100, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200,
              200, 200, 200, 200,
            ]}
          />
        ) : (
          <Empty style={{ margin: "60px" }} />
        )}        
      </div>
       <Pagination
              style={{ margin: "20px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={sourcingDetailsTotalCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
            />      

    </div>
  );
}
